import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Card, Typography, Stack, Link } from '@mui/material';
// utils
import { fNumber, fPercent } from '../../utils/formatNumber';
// components
import Iconify from '../../components/iconify';

AppWidgetSummary.propTypes = {
  sx: PropTypes.object,
  chart: PropTypes.object,
  title: PropTypes.string,
  link: PropTypes.string,
  total: PropTypes.number,
  percent: PropTypes.number,
  query: PropTypes.string
};

export default function AppWidgetSummary({ link, title, percent, total, chart, sx, query, ...other }) {
  return (
    <Link component={RouterLink} to={link}>
      <Card sx={{ display: 'flex', alignItems: 'center', p: 3, ...sx }} {...other}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle2">{title}</Typography>

          {/* <TrendingInfo percent={percent} /> */}

          <Typography variant="h3">{fNumber(total)}</Typography>
        </Box>
        {/* <Chart
          type="bar"
          series={[{ data: series }]}
          options={chartOptions}
          width={60}
          height={36}
        /> */}
      </Card>
    </Link>
  );
}
TrendingInfo.propTypes = {
  percent: PropTypes.number,
};

function TrendingInfo({ percent }) {
  return (
    <Stack direction="row" alignItems="center" sx={{ mt: 2, mb: 1 }}>
      <Iconify
        icon={percent < 0 ? 'eva:trending-down-fill' : 'eva:trending-up-fill'}
        sx={{
          mr: 1,
          p: 0.5,
          width: 24,
          height: 24,
          borderRadius: '50%',
          color: 'success.main',
          bgcolor: (theme) => alpha(theme.palette.success.main, 0.16),
          ...(percent < 0 && {
            color: 'error.main',
            bgcolor: (theme) => alpha(theme.palette.error.main, 0.16),
          }),
        }}
      />

      <Typography component="div" variant="subtitle2">
        {percent > 0 && '+'}

        {fPercent(percent)}
      </Typography>
    </Stack>
  );
}
